import React from 'react';
import DakshinaPricingControl from '../../components/pricing/DakshinaPricingControl';

export const ServiceDetailsHeader = ({ onNavigate, serviceData, parentPage, parentLabel }) => (
  <div className="bg-white border-b border-gray-200">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4">
      <nav className="flex items-center space-x-2 text-sm text-gray-600">
        <button
          type="button"
          onClick={() => onNavigate && onNavigate('home')}
          className="hover:text-rose-600 transition-colors"
        >
          Home
        </button>
        <span>•</span>
        <button
          type="button"
          onClick={() => onNavigate && onNavigate(parentPage || 'home')}
          className="hover:text-rose-600 transition-colors"
        >
          {parentLabel || 'Services'}
        </button>
        <span>•</span>
        <span className="text-gray-900 font-medium">{serviceData.title}</span>
      </nav>
    </div>
  </div>
);

export const ServiceDetailsMainSection = ({
  serviceData,
  serviceProfile,
  servicePricingConfig,
  schedulePricing,
  jaapPricing,
  anusthanPricing,
  selectedDurationDays,
  setSelectedDurationDays,
  selectedPanditCount,
  setSelectedPanditCount,
  panditCountOptions,
  selectedJaapCount,
  setSelectedJaapCount,
  selectedJaapOption,
  selectedAnusthanType,
  setSelectedAnusthanType,
  selectedAnusthanOption,
  anusthanPanditOptions,
  detailedInfo,
  demandHighlightedServices,
  onNavigateDemandService,
  serviceExecutionDetails,
  packages,
  selectedPackage,
  setSelectedPackage,
  dakshinaAmount,
  setDakshinaAmount,
  addOnServices,
  selectedAddOns,
  handleAddOnToggle,
  formatPrice,
  calculateTotalPrice,
  pricingBreakdown,
  handleBookNow,
  frequentSuggestion,
  suggestedPandit,
  handleBookWithPandit,
  cityFilter,
  setCityFilter,
  sortBy,
  setSortBy,
  onlyAvailable,
  setOnlyAvailable,
  catalogLoading,
  availabilityLoading,
  rankedProviders,
  handleViewPanditProfile
}) => (
  <div className="bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
      <div className="grid lg:grid-cols-2 gap-8 lg:gap-12">
        <div>
          <div className="bg-gradient-to-br from-rose-50 to-pink-50 rounded-2xl p-8 text-center mb-6">
            <div className="text-8xl mb-4">{serviceData.image}</div>
            <div className="flex items-center justify-center space-x-4 text-sm text-gray-600">
              <span className="flex items-center space-x-1">
                <span className="text-yellow-500">⭐</span>
                <span className="font-medium">{serviceData.rating}</span>
              </span>
              <span>•</span>
              <span>{serviceData.reviews} reviews</span>
              <span>•</span>
              <span className="text-rose-600 font-medium">Verified Service</span>
            </div>
          </div>

          <div className="bg-gray-50 rounded-xl p-6 mb-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-3">About This Service</h3>
            <p className="text-gray-600 leading-relaxed mb-4">{serviceData.description}</p>
            <p className="text-gray-600 leading-relaxed">
              Our experienced pandits ensure that every ritual is performed according to traditional Vedic customs,
              creating a sacred and memorable ceremony for your special day. We provide complete guidance and
              support throughout the entire ceremony.
            </p>
            <div className="mt-4 grid sm:grid-cols-2 gap-3">
              <div className="bg-white border border-gray-200 rounded-lg px-3 py-2">
                <div className="text-xs uppercase tracking-wide text-gray-500">Pandit Team</div>
                <div className="text-sm font-medium text-gray-900">{serviceExecutionDetails.pandits}</div>
              </div>
              <div className="bg-white border border-gray-200 rounded-lg px-3 py-2">
                <div className="text-xs uppercase tracking-wide text-gray-500">Completion Time</div>
                <div className="text-sm font-medium text-gray-900">{serviceExecutionDetails.duration}</div>
              </div>
            </div>
          </div>

          <div className="bg-white border border-gray-200 rounded-xl p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">What's Included</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {serviceData.features.map((feature, index) => (
                <div key={index} className="flex items-center space-x-3">
                  <span className="text-rose-600 text-lg">✓</span>
                  <span className="text-gray-700">{feature}</span>
                </div>
              ))}
            </div>
          </div>

          {detailedInfo && (
            <div className="bg-white border border-gray-200 rounded-xl p-6 mt-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">Complete Details</h3>
              <ul className="space-y-2 text-sm text-gray-700">
                {(detailedInfo.highlights || []).map((item, index) => (
                  <li key={index} className="flex items-start">
                    <span className="text-rose-600 mr-2">•</span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
              {detailedInfo.note && (
                <p className="text-xs text-gray-600 mt-3 bg-gray-50 border border-gray-200 rounded-md p-2">
                  {detailedInfo.note}
                </p>
              )}
            </div>
          )}

          {Array.isArray(demandHighlightedServices) && demandHighlightedServices.length > 0 && (
            <div className="bg-white border border-gray-200 rounded-xl p-6 mt-6">
              <div className="flex items-center justify-between mb-3">
                <h3 className="text-lg font-semibold text-gray-900">Most Requested Services</h3>
                <span className="text-xs text-gray-500">Demand based</span>
              </div>
              <div className="grid sm:grid-cols-2 gap-3">
                {demandHighlightedServices.slice(0, 6).map((item) => (
                  <button
                    key={item.id}
                    type="button"
                    onClick={() => onNavigateDemandService && onNavigateDemandService(item)}
                    className="text-left border border-gray-200 rounded-lg p-3 hover:border-rose-300 hover:bg-rose-50 transition-colors"
                  >
                    <div className="flex items-start justify-between gap-2">
                      <div>
                        <div className="font-medium text-gray-900 text-sm">{item.title}</div>
                        {item.category && (
                          <div className="inline-flex mt-1 px-2 py-0.5 text-[10px] rounded-full bg-gray-100 text-gray-600 border border-gray-200">
                            {item.category}
                          </div>
                        )}
                        <div className="text-xs text-gray-600 mt-1 line-clamp-2">{item.description}</div>
                        <div className="text-[11px] text-gray-500 mt-1">{item.duration}</div>
                        {Array.isArray(item.aliases) && item.aliases.length > 0 && (
                          <div className="text-[10px] text-gray-500 mt-1 truncate">
                            Also known as: {item.aliases.slice(0, 2).join(', ')}
                          </div>
                        )}
                      </div>
                      <div className="text-xl">{item.image}</div>
                    </div>
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>

        <div>
          <div className="bg-white border border-gray-200 rounded-xl p-6 sticky top-4">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">{serviceData.title}</h1>
            <p className="text-gray-600 mb-6">{serviceProfile.subtitle}</p>

            <div className="mb-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Choose Package</h3>
              <div className="space-y-3">
                {Object.entries(packages).map(([key, pkg]) => (
                  <label
                    key={key}
                    className={`block p-4 border rounded-lg cursor-pointer transition-colors ${
                      selectedPackage === key
                        ? 'border-rose-500 bg-rose-50'
                        : 'border-gray-200 hover:border-gray-300'
                    }`}
                  >
                    <input
                      type="radio"
                      name="package"
                      value={key}
                      checked={selectedPackage === key}
                      onChange={(event) => setSelectedPackage(event.target.value)}
                      className="sr-only"
                    />
                    <div className="flex justify-between items-start">
                      <div>
                        <div className="font-medium text-gray-900">{pkg.name}</div>
                        <div className="text-sm text-gray-600 mt-1">{pkg.description}</div>
                        <div className="text-sm text-gray-500 mt-1">Duration: {pkg.duration}</div>
                      </div>
                      <div className="text-right">
                        <div className="text-lg font-bold text-gray-900">{formatPrice(pkg.price)}</div>
                      </div>
                    </div>
                  </label>
                ))}
              </div>
            </div>

            {servicePricingConfig?.dakshina && (
              <DakshinaPricingControl
                min={servicePricingConfig.dakshina.min}
                max={servicePricingConfig.dakshina.max}
                step={servicePricingConfig.dakshina.step}
                value={dakshinaAmount}
                onChange={setDakshinaAmount}
                formatPrice={formatPrice}
                platformFeeNote={servicePricingConfig.platformFeeNote}
              />
            )}

            {schedulePricing?.mode === 'per-pandit-per-day' && (
              <div className="mb-6 bg-indigo-50 border border-indigo-200 rounded-xl p-4">
                <h3 className="text-base font-semibold text-indigo-900 mb-2">Customize Ritual Plan</h3>
                <p className="text-sm text-indigo-800 mb-3">
                  Pricing: {formatPrice(schedulePricing.ratePerPanditPerDay)} per pandit/day.
                </p>
                <div className="grid sm:grid-cols-2 gap-3">
                  <label className="text-sm text-indigo-900">
                    <div className="mb-1">Number of Days</div>
                    <select
                      value={selectedDurationDays}
                      onChange={(event) => setSelectedDurationDays(Number(event.target.value))}
                      className="w-full border border-indigo-200 rounded-md px-2 py-2 bg-white"
                    >
                      {(schedulePricing.dayOptions || []).map((days) => (
                        <option key={days} value={days}>{days} day(s)</option>
                      ))}
                    </select>
                  </label>

                  <label className="text-sm text-indigo-900">
                    <div className="mb-1">Pandit Count</div>
                    <select
                      value={selectedPanditCount}
                      onChange={(event) => setSelectedPanditCount(Number(event.target.value))}
                      className="w-full border border-indigo-200 rounded-md px-2 py-2 bg-white"
                    >
                      {panditCountOptions.map((count) => (
                        <option key={count} value={count}>{count} pandit(s)</option>
                      ))}
                    </select>
                  </label>
                </div>
                <p className="text-xs text-indigo-700 mt-3">
                  Total ritual charges are calculated automatically based on selected days and pandit count.
                </p>
              </div>
            )}

            {jaapPricing?.mode === 'jaap-count' && (
              <div className="mb-6 bg-indigo-50 border border-indigo-200 rounded-xl p-4">
                <h3 className="text-base font-semibold text-indigo-900 mb-2">Select Jaap Count</h3>
                <label className="text-sm text-indigo-900 block">
                  <div className="mb-1">Jaap Package</div>
                  <select
                    value={selectedJaapCount}
                    onChange={(event) => setSelectedJaapCount(Number(event.target.value))}
                    className="w-full border border-indigo-200 rounded-md px-2 py-2 bg-white"
                  >
                    {(jaapPricing.options || []).map((option) => (
                      <option key={option.count} value={option.count}>{option.label}</option>
                    ))}
                  </select>
                </label>
                {selectedJaapOption && (
                  <div className="text-xs text-indigo-700 mt-3">
                    {selectedJaapOption.pandits} • {selectedJaapOption.duration}
                  </div>
                )}
              </div>
            )}

            {anusthanPricing?.mode === 'anusthan-pandit' && (
              <div className="mb-6 bg-indigo-50 border border-indigo-200 rounded-xl p-4">
                <h3 className="text-base font-semibold text-indigo-900 mb-2">Select Anusthan Plan</h3>
                <div className="grid sm:grid-cols-2 gap-3">
                  <label className="text-sm text-indigo-900">
                    <div className="mb-1">Anusthan Type</div>
                    <select
                      value={selectedAnusthanType}
                      onChange={(event) => setSelectedAnusthanType(event.target.value)}
                      className="w-full border border-indigo-200 rounded-md px-2 py-2 bg-white"
                    >
                      {(anusthanPricing.types || []).map((type) => (
                        <option key={type.key} value={type.key}>{type.label}</option>
                      ))}
                    </select>
                  </label>

                  <label className="text-sm text-indigo-900">
                    <div className="mb-1">Pandit Count</div>
                    <select
                      value={selectedPanditCount}
                      onChange={(event) => setSelectedPanditCount(Number(event.target.value))}
                      className="w-full border border-indigo-200 rounded-md px-2 py-2 bg-white"
                    >
                      {anusthanPanditOptions.map((count) => (
                        <option key={count} value={count}>{count} pandit(s)</option>
                      ))}
                    </select>
                  </label>
                </div>
                {selectedAnusthanOption && (
                  <div className="text-xs text-indigo-700 mt-3">
                    {selectedAnusthanOption.duration} • {formatPrice(selectedAnusthanOption.basePricePerPandit)} per pandit
                  </div>
                )}
              </div>
            )}

            <div className="mb-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Add-on Services</h3>
              <div className="space-y-3 max-h-64 overflow-y-auto">
                {addOnServices.map((addOn) => (
                  <label
                    key={addOn.id}
                    className={`block p-3 border rounded-lg cursor-pointer transition-colors ${
                      selectedAddOns.includes(addOn.id)
                        ? 'border-rose-500 bg-rose-50'
                        : 'border-gray-200 hover:border-gray-300'
                    }`}
                  >
                    <input
                      type="checkbox"
                      checked={selectedAddOns.includes(addOn.id)}
                      onChange={() => handleAddOnToggle(addOn.id)}
                      className="sr-only"
                    />
                    <div className="flex justify-between items-start">
                      <div className="flex-1">
                        <div className="font-medium text-gray-900">{addOn.name}</div>
                        <div className="text-sm text-gray-600 mt-1">{addOn.description}</div>
                      </div>
                      <div className="text-right ml-4">
                        <div className="font-bold text-gray-900">+{formatPrice(addOn.price)}</div>
                      </div>
                    </div>
                  </label>
                ))}
              </div>
            </div>

            <div className="border-t border-gray-200 pt-4 mb-6">
              {(pricingBreakdown?.platformFee > 0 || pricingBreakdown?.addOns > 0) && (
                <div className="space-y-1 mb-3 text-sm">
                  <div className="flex justify-between text-gray-700">
                    <span>{pricingBreakdown.baseLabel || 'Package Price'}</span>
                    <span>{formatPrice(pricingBreakdown.dakshina)}</span>
                  </div>
                  {pricingBreakdown.schedule && (
                    <div className="text-xs text-gray-500">
                      {pricingBreakdown.schedule.pandits} pandit(s) x {pricingBreakdown.schedule.days} day(s) x {formatPrice(pricingBreakdown.schedule.ratePerPanditPerDay)}
                    </div>
                  )}
                  {pricingBreakdown.jaapSelection && (
                    <div className="text-xs text-gray-500">
                      {pricingBreakdown.jaapSelection.label} • {pricingBreakdown.jaapSelection.pandits} • {pricingBreakdown.jaapSelection.duration}
                    </div>
                  )}
                  {pricingBreakdown.anusthanSelection && (
                    <div className="text-xs text-gray-500">
                      {pricingBreakdown.anusthanSelection.type}: {pricingBreakdown.anusthanSelection.pandits} pandit(s) x {formatPrice(pricingBreakdown.anusthanSelection.ratePerPandit)}
                    </div>
                  )}
                  {pricingBreakdown.platformFee > 0 && (
                    <div className="flex justify-between text-gray-700">
                      <span>Platform Fee</span>
                      <span>{formatPrice(pricingBreakdown.platformFee)}</span>
                    </div>
                  )}
                  {pricingBreakdown.addOns > 0 && (
                    <div className="flex justify-between text-gray-700">
                      <span>Add-ons</span>
                      <span>{formatPrice(pricingBreakdown.addOns)}</span>
                    </div>
                  )}
                </div>
              )}
              <div className="flex justify-between items-center">
                <span className="text-lg font-semibold text-gray-900">Total Price:</span>
                <span className="text-2xl font-bold text-rose-600">{formatPrice(calculateTotalPrice())}</span>
              </div>
              <div className="text-sm text-gray-600 mt-1">*Final price may vary based on specific requirements</div>
            </div>

            <div className="space-y-3">
              <button
                onClick={handleBookNow}
                className="w-full bg-rose-600 hover:bg-rose-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors"
              >
                Book Now - {formatPrice(calculateTotalPrice())}
              </button>
              <button
                onClick={() => console.log('Contact for consultation')}
                className="w-full bg-white border border-gray-300 text-gray-700 font-medium py-3 px-6 rounded-lg hover:bg-gray-50 transition-colors"
              >
                📞 Free Consultation
              </button>
            </div>

            {frequentSuggestion?.panditName && (
              <div className="mt-4 bg-indigo-50 border border-indigo-200 rounded-lg p-4">
                <div className="text-sm text-indigo-900 font-semibold">Recommended from your previous bookings</div>
                <p className="text-sm text-indigo-700 mt-1">Rebook with {suggestedPandit?.name || frequentSuggestion.panditName}</p>
                <button
                  onClick={() => handleBookWithPandit(suggestedPandit || {
                    id: frequentSuggestion.panditId,
                    userId: frequentSuggestion.panditId,
                    name: frequentSuggestion.panditName,
                    location: frequentSuggestion.panditLocation || 'Preferred location'
                  })}
                  className="mt-2 text-sm bg-indigo-600 text-white px-3 py-1.5 rounded-md hover:bg-indigo-700"
                >
                  Book This Pandit
                </button>
              </div>
            )}

            <div className="mt-4 border-t border-gray-200 pt-4">
              <h4 className="text-sm font-semibold text-gray-900 mb-3">Prefer booking a specific pandit?</h4>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mb-3">
                <input
                  type="text"
                  value={cityFilter}
                  onChange={(event) => setCityFilter(event.target.value)}
                  className="text-xs border border-gray-300 rounded-md px-2 py-1.5"
                  placeholder="Filter by city"
                />
                <select
                  value={sortBy}
                  onChange={(event) => setSortBy(event.target.value)}
                  className="text-xs border border-gray-300 rounded-md px-2 py-1.5"
                >
                  <option value="best">Sort: Best match</option>
                  <option value="rating">Sort: Highest rating</option>
                  <option value="experience">Sort: Most experienced</option>
                </select>
              </div>
              <label className="flex items-center text-xs text-gray-700 mb-3">
                <input
                  type="checkbox"
                  checked={onlyAvailable}
                  onChange={(event) => setOnlyAvailable(event.target.checked)}
                  className="mr-2"
                />
                Show only available this week
              </label>
              {(catalogLoading || availabilityLoading) && (
                <p className="text-xs text-gray-500 mb-2">Refreshing provider data...</p>
              )}
              <p className="text-xs text-gray-500 mb-2">{rankedProviders.length} providers found</p>
              {!catalogLoading && rankedProviders.length === 0 && (
                <p className="text-xs text-gray-500 mb-2">No pandits found from catalog for current filters.</p>
              )}
              <div className="space-y-2 max-h-44 overflow-y-auto">
                {rankedProviders.slice(0, 6).map((pandit) => (
                  <div key={pandit.id} className="w-full border border-gray-200 rounded-md px-3 py-2 hover:border-rose-300 hover:bg-rose-50 transition-colors">
                    <div className="flex justify-between items-center">
                      <div>
                        <div className="text-sm font-medium text-gray-900">{pandit.name}</div>
                        <div className="text-xs text-gray-600">{pandit.location} • {pandit.experienceYears || 0} yrs exp</div>
                        <div className="text-[11px] text-gray-500 mt-0.5">
                          {pandit.serviceHits > 0 ? `${pandit.serviceHits} service match` : 'General match'}
                          {' • '}
                          {pandit.isAvailable ? 'Available this week' : 'Availability unknown'}
                        </div>
                      </div>
                      <div className="text-right">
                        <span className="text-xs text-amber-700">⭐ {Number(pandit.rating || 0).toFixed(1)}</span>
                        <div className={`text-[11px] mt-1 ${pandit.isAvailable ? 'text-green-700' : 'text-gray-500'}`}>
                          {pandit.isAvailable ? '● Available' : '● Not confirmed'}
                        </div>
                      </div>
                    </div>
                    <div className="mt-2 flex gap-2">
                      <button
                        onClick={() => handleBookWithPandit(pandit)}
                        className="text-xs bg-rose-600 text-white px-2.5 py-1 rounded-md hover:bg-rose-700"
                      >
                        Book
                      </button>
                      <button
                        onClick={() => handleViewPanditProfile(pandit)}
                        className="text-xs bg-white text-gray-700 border border-gray-300 px-2.5 py-1 rounded-md hover:bg-gray-50"
                      >
                        View Profile
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="mt-6 bg-green-50 border border-green-200 rounded-lg p-4">
              <div className="flex items-start space-x-3">
                <span className="text-green-600 text-xl">🛡️</span>
                <div>
                  <div className="font-medium text-green-800">Service Guarantee</div>
                  <div className="text-sm text-green-700 mt-1">
                    100% satisfaction guaranteed. Professional service with traditional authenticity.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export const ServiceReviewsSection = ({ serviceReviews }) => (
  <div className="bg-gray-50 py-12">
    <div className="max-w-7xl mx-auto px-4 sm:px-6">
      <h2 className="text-3xl font-bold text-gray-900 text-center mb-8">Customer Reviews</h2>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {serviceReviews.map((review, index) => (
          <div key={index} className="bg-white border border-gray-200 rounded-lg p-6">
            <div className="flex items-center space-x-1 mb-3">
              {[...Array(5)].map((_, i) => (
                <span key={i} className={`text-sm ${i < review.rating ? 'text-yellow-500' : 'text-gray-300'}`}>
                  ⭐
                </span>
              ))}
            </div>
            <p className="text-gray-600 mb-4">"{review.comment}"</p>
            <div className="flex justify-between items-center">
              <span className="font-medium text-gray-900">{review.name}</span>
              <span className="text-sm text-gray-500">{review.date}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export const ServiceFaqSection = ({ serviceFaqs }) => (
  <div className="bg-white py-12">
    <div className="max-w-4xl mx-auto px-4 sm:px-6">
      <h2 className="text-3xl font-bold text-gray-900 text-center mb-8">Frequently Asked Questions</h2>
      <div className="space-y-6">
        {serviceFaqs.map((faq, index) => (
          <div key={index} className="border border-gray-200 rounded-lg p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">{faq.question}</h3>
            <p className="text-gray-600">{faq.answer}</p>
          </div>
        ))}
      </div>
    </div>
  </div>
);
